import React from 'react';
import AsyncSelect from 'react-select/async';
import api from '../../../services/apiClient';

function IngredientList({ ingredients = [], onChange, readOnly }) {
  const maxLines = 9;

  const loadOptions = async (inputValue) => {
    if (!inputValue) return [];
    try {
      const res = await api.get(`/api/ingredients/autocomplete?q=${inputValue}`);
      return res.data.map((item) => ({
        label: item.label,
        value: item.value,
        unit: item.unit,
      }));
    } catch (err) {
      console.error('❌ Ingredient autocomplete failed:', err);
      return [];
    }
  };

  const handleSelectChange = (selected, index) => {
    const updated = [...ingredients];
    updated[index] = {
      label: selected?.label || '',
      value: selected?.value || null,
      unit: selected?.unit || '',
      quantity: updated[index]?.quantity || '',
    };
    onChange(index, updated[index]);
  };

  const handleQuantityChange = (e, index) => {
    const updated = [...ingredients];
    updated[index] = {
      ...updated[index],
      quantity: e.target.value,
    };
    onChange(index, updated[index]);
  };

  return (
    <div className="w-full h-full flex flex-col text-[#5a3e36] pt-0 pb-0">
      <label className="text-[clamp(0.65rem,1vw,0.875rem)] font-semibold text-center mb-0 leading-tight">
        Ingredients:
      </label>

      <div className="flex flex-col justify-between h-full w-full overflow-hidden p-0 m-0">
        {Array.from({ length: maxLines }).map((_, i) => {
          const ing = ingredients[i] || {};

          return (
            <div
  key={i}
  className="w-full min-w-0 h-[11.111%] min-h-[28px] rounded-sm border border-[#e0c3a5] bg-[#fffefc] overflow-hidden"
>
              {/* Ingredient Name */}
              <div className="flex-[0.5] md:flex-[0.7] border-b border-[#e0c3a5] px-[3px] flex items-center text-[8px] md:text-[clamp(0.5rem,0.75vw,0.625rem)] text-[#5a3e36] font-medium leading-none">
                {readOnly ? (
                  <span className="truncate w-full">
                    {(ing?.label || ing?.name || ing?.ingredient?.name)?.trim()
                      || <span className="text-transparent select-none">.</span>}
                  </span>
                ) : (
                  <AsyncSelect
                    value={ing.value ? { label: ing.label, value: ing.value, unit: ing.unit } : null}
                    onChange={(sel) => handleSelectChange(sel, i)}
                    loadOptions={loadOptions}
                    placeholder="Ingredient"
                    className="ingredient-select w-full"
                    classNamePrefix="ingredient-select"
                    styles={{
                      control: (base, state) => ({
                      ...base,
                      minHeight: 0,
                      height: '12px',            // mobile
                      maxHeight: '12px',
                      fontSize: 8,
                      padding: 0,
                      margin: 0,
                      lineHeight: 1,
                      backgroundColor: 'transparent',
                      border: 'none',
                      boxShadow: 'none',
                      '@media (min-width: 768px)': {
                        height: '100%',          // ⬅️ Let desktop scale naturally
                        maxHeight: 'none',
                      },
                    }),
                      valueContainer: (base) => ({
                        ...base,
                        padding: '0 2px',
                      }),
                      indicatorsContainer: () => ({ display: 'none' }),
                    }}
                  />
                )}
              </div>

              {/* Qty + Unit */}
              <div className="flex flex-wrap min-w-0 h-[13px] md:flex-[0.3] w-full justify-between px-[3px] text-[7px] md:text-[clamp(0.475rem,0.7vw,0.6rem)] leading-none">
                {/* Qty */}
                <div className="flex items-center gap-[1px] w-[48%] border-r border-[#e0c3a5] pr-[2px]">
                  <span className="italic leading-none text-[6.75px]">Qty:</span>
                  {readOnly ? (
                    <span>{ing?.quantity?.toString().trim()
                      || <span className="text-transparent select-none">.</span>}</span>
                  ) : (
                    <input
                      type="number"
                      value={ing.quantity || ''}
                      onChange={(e) => handleQuantityChange(e, i)}
                      className="w-[20px] md:w-[clamp(2rem,3.25vw,3rem)] h-full text-right bg-transparent text-[6.75px] italic appearance-none border-none outline-none focus:outline-none focus:ring-0"
                    />
                  )}
                </div>

                {/* Unit */}
                <div className="flex items-center gap-[1px] w-[48%] pl-[2px]">
                  <span className="italic leading-none text-[6.75px]">Unit:</span>
                  {readOnly ? (
                    <span>{ing?.unit?.trim()
                      || <span className="text-transparent select-none">.</span>}</span>
                  ) : (
                    <input
                      type="text"
                      value={ing.unit || ''}
                      onChange={(e) => onChange(i, { ...ing, unit: e.target.value })}
                      className="w-[20px] md:w-[clamp(2rem,3.25vw,3rem)] h-full text-right bg-transparent text-[6.75px] italic appearance-none border-none outline-none focus:outline-none focus:ring-0"
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default IngredientList;

